import jsPDF from "jspdf";
import { font, fontBold } from "@/assets/fonts/Sarabun-normal.js";

export default {
    methods: {
        async generatePdf() {
            try {
                this.isDisableDownloadReportBtn = true;

                let pdf = new jsPDF(this.pdfOption);

                const pdf_width = pdf.internal.pageSize.width;
                const pdf_height = pdf.internal.pageSize.height;

                const margin_l = this.pdfConfig.margin.l;
                const margin_t = this.pdfConfig.margin.t;
                const margin_b = this.pdfConfig.margin.b;

                let cellHeight = 35;

                const addNewPageIfNeeded = (incrementValue) => {
                    if ((pdf_position_y + incrementValue) >= pdf_height - margin_t) {
                        pdf.addPage();
                        pdf_position_y = margin_t; // Reset the position to the top of the new page
                    } else {
                        pdf_position_y += incrementValue; // Add the input value
                    }
                };

                let pdf_position_y = 0;
                pdf.addFileToVFS("Sarabun-Regular.ttf", fontBold);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "bold");
                pdf.addFileToVFS("Sarabun-Regular.ttf", font);
                pdf.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");

                pdf.setFont("Sarabun", "bold");
                pdf.setFontSize(this.pdfConfig.typo.header);
                pdf_position_y += margin_t;

                let reportTitle = this.tabIndex === 0 ? "รายงานสรุปประวัติการเรียนแยกตามคอร์ส" : "รายงานสรุปประวัติการเรียนแยกตามบทเรียน";
                this.thaitext(
                    pdf,
                    reportTitle,
                    pdf_width / 2,
                    pdf_position_y,
                    0,
                    "center"
                );
                addNewPageIfNeeded(this.pdfConfig.endLegend);

                pdf.setFont("Sarabun", "normal");
                pdf.setFontSize(this.pdfConfig.typo.extraSmall);

                let hasEnrollDate = this.dateRange?.start ? true : false;
                let startDate = "";
                let endDate = "";
                if (hasEnrollDate) {
                    startDate = this.moment(this.dateRange.start).format("YYYY-MM-DD");
                    endDate = this.moment(this.dateRange.end).format("YYYY-MM-DD");
                }
                this.thaitext(
                    pdf,
                    "ข้อมูลวันที่ : " + (hasEnrollDate ? this.formatDateToThai(startDate, false) + ' - ' + this.formatDateToThai(endDate, false) : '-'),
                    pdf_width - 20,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ผู้พิมพ์ข้อมูล : " + ' ' + this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    pdf_width - 20,
                    pdf_position_y,
                    0,
                    "right"
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                this.thaitext(
                    pdf,
                    "สถาบัน : " + this.instituteName,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "รูปแบบคอร์ส : " + this.courseType,
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "วิชา : " + (this.selectedSubjectText || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "ชื่อคอร์ส : " + (this.selectedCourse?.courseName || 'ทั้งหมด'),
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endNormal);

                this.thaitext(
                    pdf,
                    "รวม : " + this.sortedData.length + " รายการ",
                    margin_l,
                    pdf_position_y
                );
                addNewPageIfNeeded(this.pdfConfig.endRow);

                const tableHeader = ["ลำดับ", "รหัสนักเรียน", "ชื่อนักเรียน", "วันที่ลงทะเบียน", "รหัสคอร์ส", "ชื่อคอร์ส", "นาทีที่ใช้ไป\n(ชั่วโมง:นาที:วินาที)", "รูปแบบคอร์ส"];
                let colWidths = [30, 60, 100, 70, 70, 100, 80, 80];

                if (this.tabIndex === 1) {
                    tableHeader.splice(6, 0, "ชื่อบทเรียน");
                    colWidths = [30, 60, 90, 50, 70, 90, 80, 70, 50]
                }
                let headerX = 20;
                pdf.setLineWidth(0.1);

                const fontSize = pdf.getFontSize();
                const fontHeight = fontSize * 0.3528;
                const lineSpacing = 8; // Extra padding between multiline texts

                const renderTableHeader = () => {
                    pdf.setFont("Sarabun", "bold");

                    for (let i = 0; i < tableHeader.length; i++) {
                        const width = colWidths[i];

                        // 1. Draw Header Cell Border
                        pdf.rect(headerX, pdf_position_y, width, cellHeight);

                        // 2. Split text by newline for multiline support
                        const lines = tableHeader[i].split('\n');
                        const totalLines = lines.length;

                        // Calculate the starting Y position so the entire block of text is vertically centered
                        const totalTextHeight = (totalLines * fontHeight) + ((totalLines - 1) * lineSpacing);
                        let startY = pdf_position_y + (cellHeight - totalTextHeight) / 2 + fontHeight;

                        // 3. Loop through and center each individual line
                        for (let j = 0; j < totalLines; j++) {
                            const lineText = lines[j];

                            // Calculate horizontal center for the current line
                            const textWidth = pdf.getStringUnitWidth(lineText) * fontSize / pdf.internal.scaleFactor;
                            const textX = headerX + (width - textWidth) / 2;

                            // Render the text using your custom Thai text function
                            this.thaitext(pdf, lineText, textX, startY);

                            // Move Y down for the next line
                            startY += fontHeight + lineSpacing;
                        }

                        headerX += width;
                    }
                    pdf_position_y += cellHeight;

                    pdf.setFont("Sarabun", "normal");
                    cellHeight = 30
                }

                // Create table header
                renderTableHeader();

                const maxPrintableY = pdf_height - margin_b;

                if (this.sortedData.length > 0) {
                    this.sortedData.forEach((row, index) => {
                        let columnX = margin_l;
                        const studentId = row.memberId ? row.memberId.toString() : '-';
                        const cerDate = this.thaiDateFilter(row.cerStartDate);
                        const courseCode = row.courseCode ? row.courseCode.toString() : '-';

                        // 1. Split long text into arrays of wrapped lines
                        const padding = 10;
                        const studentNameLines = pdf.splitTextToSize(row.memberName, colWidths[2] - padding);
                        const courseCodeLines = pdf.splitTextToSize(courseCode, colWidths[4] - padding);
                        const courseNameLines = pdf.splitTextToSize(row.courseName, colWidths[5] - padding);

                        // 2. Calculate heights for individual text blocks
                        const fontHeight = pdf.getFontSize() * 0.3528;
                        const lineSpacing = 8;
                        const calculatedStudentNameHeight = (studentNameLines.length * fontHeight) + ((studentNameLines.length - 1) * lineSpacing) + 10;
                        const calculatedCourseCodeHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing) + 10;
                        const calculatedCourseNameHeight = (courseNameLines.length * fontHeight) + ((courseNameLines.length - 1) * lineSpacing) + 10;

                        // 3. Find the maximum height for the entire row
                        let finalRowHeight = Math.max(cellHeight, calculatedStudentNameHeight, calculatedCourseCodeHeight, calculatedCourseNameHeight);

                        let lectureName = "";
                        let lectureNameLines = null;
                        let calculatedLectureNameHeight = null;

                        if (this.tabIndex === 1) {
                            lectureName = row.lectureName ? row.lectureName : '-';
                            lectureNameLines = pdf.splitTextToSize(lectureName, colWidths[6] - padding);
                            calculatedLectureNameHeight = (lectureNameLines.length * fontHeight) + ((lectureNameLines.length - 1) * lineSpacing) + 10;
                            finalRowHeight = Math.max(cellHeight, calculatedStudentNameHeight, calculatedCourseCodeHeight, calculatedCourseNameHeight, calculatedLectureNameHeight);
                        }

                        // ==========================================
                        // CRITICAL FIX: AUTOMATIC PAGE BREAK CHECK
                        // ==========================================
                        if (pdf_position_y + finalRowHeight > maxPrintableY) {
                            pdf.addPage();
                            pdf_position_y = margin_t; // Reset to the top of the new page

                            // RE-DRAW TABLE HEADERS ON THE NEW PAGE
                            headerX = 20;
                            renderTableHeader();
                        }

                        // ==========================================

                        // --- DRAW COLUMN 1: No. ---
                        pdf.rect(columnX, pdf_position_y, colWidths[0], finalRowHeight);
                        const idxText = (index + 1).toString();
                        const idxWidth = pdf.getStringUnitWidth(idxText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                        this.thaitext(pdf, idxText, columnX + (colWidths[0] - idxWidth) / 2, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[0];

                        // --- DRAW COLUMN 2: Student ID ---
                        pdf.rect(columnX, pdf_position_y, colWidths[1], finalRowHeight);
                        this.thaitext(pdf, studentId, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[1];

                        // --- DRAW COLUMN 3: Student Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[2], finalRowHeight);
                        const totalStudentNameHeight = (studentNameLines.length * fontHeight) + ((studentNameLines.length - 1) * lineSpacing);
                        let studentNameY = pdf_position_y + (finalRowHeight - totalStudentNameHeight) / 2 + fontHeight;
                        studentNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, studentNameY);
                            studentNameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[2];

                        // --- DRAW COLUMN 4: Enroll Date ---
                        pdf.rect(columnX, pdf_position_y, colWidths[3], finalRowHeight);
                        this.thaitext(pdf, cerDate, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[3];

                        // --- DRAW COLUMN 5: Course Code ---
                        pdf.rect(columnX, pdf_position_y, colWidths[4], finalRowHeight);
                        const totalCourseCodeHeight = (courseCodeLines.length * fontHeight) + ((courseCodeLines.length - 1) * lineSpacing);
                        let courseCodeY = pdf_position_y + (finalRowHeight - totalCourseCodeHeight) / 2 + fontHeight;
                        courseCodeLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, courseCodeY);
                            courseCodeY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[4];

                        // --- DRAW COLUMN 6: Course Name ---
                        pdf.rect(columnX, pdf_position_y, colWidths[5], finalRowHeight);
                        const totalCourseNameHeight = (courseNameLines.length * fontHeight) + ((courseNameLines.length - 1) * lineSpacing);
                        let courseNameY = pdf_position_y + (finalRowHeight - totalCourseNameHeight) / 2 + fontHeight;
                        courseNameLines.forEach((line) => {
                            this.thaitext(pdf, line, columnX + 5, courseNameY);
                            courseNameY += fontHeight + lineSpacing;
                        });
                        columnX += colWidths[5];

                        let colIdx = 6;

                        if (this.tabIndex === 1) {
                            // --- DRAW COLUMN 7: Lecture Name ---
                            pdf.rect(columnX, pdf_position_y, colWidths[colIdx], finalRowHeight);
                            const totalLectureNameHeight = (lectureNameLines.length * fontHeight) + ((lectureNameLines.length - 1) * lineSpacing);
                            let lectureNameY = pdf_position_y + (finalRowHeight - totalLectureNameHeight) / 2 + fontHeight;
                            lectureNameLines.forEach((line) => {
                                this.thaitext(pdf, line, columnX + 5, lectureNameY);
                                lectureNameY += fontHeight + lineSpacing;
                            });
                            columnX += colWidths[colIdx];
                            colIdx++;
                        }

                        // --- DRAW COLUMN 7: Learning Time ---
                        pdf.rect(columnX, pdf_position_y, colWidths[colIdx], finalRowHeight);
                        this.thaitext(pdf, row.learningTime, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[colIdx];
                        colIdx++;

                        // --- DRAW COLUMN 8: Course Type ---
                        pdf.rect(columnX, pdf_position_y, colWidths[colIdx], finalRowHeight);
                        this.thaitext(pdf, row.courseFormat, columnX + 5, pdf_position_y + (finalRowHeight - fontHeight) / 2 + fontHeight);
                        columnX += colWidths[colIdx];

                        // 4. Move Y down cleanly by the shared unified row height
                        pdf_position_y += finalRowHeight;
                    });
                } else {
                    let currentX = margin_l;
                    cellHeight = 25;

                    // Combine widths of Column for the text "รวมทั้งหมด"
                    const spanWidth = colWidths.reduce(
                        (accumulator, currentValue) => accumulator + currentValue,
                        0,
                    );

                    pdf.setFillColor(240, 240, 240);
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'F');
                    pdf.rect(currentX, pdf_position_y, spanWidth, cellHeight, 'S');

                    const labelText = 'ไม่มีข้อมูล';
                    const totalWidth = pdf.getStringUnitWidth(labelText) * pdf.getFontSize() / pdf.internal.scaleFactor;
                    // Center align the total number in the last column
                    const totalX = currentX + (spanWidth - totalWidth) / 2;
                    const labelY = pdf_position_y + (cellHeight - fontHeight) / 2 + fontHeight;

                    this.thaitext(pdf, labelText, totalX, labelY);
                }


                setTimeout(() => {
                    pdf.save(reportTitle + ".pdf");
                }, 0);
                this.isDisableDownloadReportBtn = false;
            } catch (error) {
                console.log(error)
            }
        }
    }
}